import Label, { LabelProps } from "./Label";

export default Label;

export type { LabelProps };
